// extracted by mini-css-extract-plugin
export default {"button":"buttonSmall_button__OxGJF","mobile":"buttonSmall_mobile__CoTOJ","tablet":"buttonSmall_tablet__zJj1g"};